"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showTeleswitch = exports.allTeleswitch = void 0;
var utils_1 = require("../../utils/utils");
var allTeleswitch = function (unitRates) {
    return !!unitRates.length &&
        unitRates.every(function (_a) {
            var _b;
            var timePatternRegime = _a.timePatternRegime;
            return (_b = (0, utils_1.getClockingHours)(timePatternRegime)) === null || _b === void 0 ? void 0 : _b.isTeleswitch;
        });
};
exports.allTeleswitch = allTeleswitch;
var showTeleswitch = function (_a) {
    var clockingHours = _a.clockingHours, allMetersAreTeleswitch = _a.allMetersAreTeleswitch, isLast = _a.isLast;
    return !!clockingHours &&
        clockingHours.isTeleswitch &&
        (!allMetersAreTeleswitch || isLast);
};
exports.showTeleswitch = showTeleswitch;
